export enum AvatarSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = '2xl',
}

export const AVATAR_SIZE_CLASS: Record<AvatarSize, string> = {
  [AvatarSize.SM]: 'size-8',
  [AvatarSize.MD]: 'size-10',
  [AvatarSize.LG]: 'size-14',
  [AvatarSize.XL]: 'size-24',
  [AvatarSize.XXL]: 'size-28',
};

export const AVATAR_ICON_SIZE: Record<AvatarSize, string> = {
  [AvatarSize.SM]: '16',
  [AvatarSize.MD]: '24',
  [AvatarSize.LG]: '32',
  [AvatarSize.XL]: '56',
  [AvatarSize.XXL]: '64',
};

export const AVATAR_TEXT_CLASS: Record<AvatarSize, string> = {
  [AvatarSize.SM]: 'text-xs font-bold',
  [AvatarSize.MD]: 'text-xs font-bold',
  [AvatarSize.LG]: 'text-xl font-semibold',
  [AvatarSize.XL]: 'text-5xl font-semibold',
  [AvatarSize.XXL]: 'text-6xl font-semibold',
};

export interface AvatarConfig {
  size: AvatarSize;
  imageUrl?: string;
  icon?: string;
  initials?: string;
  profileId?: string;
}
